import { render } from "./StoreList.vue?vue&type=template&id=78070992"
import script from "./StoreList.vue?vue&type=script&lang=js"
export * from "./StoreList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__